import { SxProps } from '@mui/material';

/**
 * Application constants.
 */

/** German date format string for dayjs. */
export const dayjsFormatDate = 'DD.MM.YYYY';

/**
 * Backend URLs.
 */
export const urlVulnerabilities = 'api/vulnerabilities';

/**
 * User specific URLs.
 */
export const urlSettings = 'api/settings';
export const urlUserProfile = 'api/user/profile';
export const urlUserLogout = 'api/user/logout';

/** Reset password URL */
export const urlResetPassword = '//passwordreset.eplass.de';

/** Styles for making an element flexbox-compatible. */
export const flexBase: SxProps = {
    display: 'flex',
    alignItems: 'center',
};

/** Styles for making an element take up all available size from its parent. */
export const fullSize: SxProps = {
    height: '100%',
    width: '100%',
};
